import moment from "moment"

export const DATE_TIME_FORMAT = {
    am_pm: (date: string) => {
        return moment(date).format('MM/DD/YYYY hh:mm A')
    }
}